__webpack_require__.p = "/tokens-buttons-input-radius-8px/account-setup/";